import { useEffect } from 'react';
import { sattVy, vyNyckel } from './moduleTracker';

/**
 * Mät vyn användaren tittar på. Byter vy när `vy` ändras (jämförs på
 * innehåll, inte referens) och skickar den uppmätta tiden när komponenten
 * avmonteras, t.ex. vid utloggning.
 *
 * @param {{moduleKey: string, vy?: string|null, flik?: string|null, projectId?: number|null}|null} vy
 * @param {'web'|'field'} kalla
 */
export default function useModulstatistik(vy, kalla = 'web') {
  const nyckel = vyNyckel(vy);
  useEffect(() => {
    sattVy(vy, kalla);
    // vy läses bara via nyckeln — samma nyckel betyder samma vy.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nyckel, kalla]);
  useEffect(() => () => sattVy(null, kalla), [kalla]);
}
